import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import UserService from "../services/user.service";
import { setUser } from "../store/slices/userSlice";

const MaxLayout = () => {
  const token = localStorage.getItem("quickfeet_user");
  const reduxUser = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const hydrateUser = async () => {
      if (!token || reduxUser) {
        return;
      }

      setIsLoading(true);
      try {
        const response = await UserService.getUserDetails();
        const userData = response?.data?.userData || response?.data?.data || null;

        if (userData) {
          dispatch(setUser(userData));
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    hydrateUser();
  }, [token, reduxUser, dispatch]);

  if (isLoading) {
    return <div className="flex justify-center py-10">Loading...</div>;
  }

  return (
    <>
      <Navbar />
      <div className="h-[calc(100vh-120px)] p-5 lg:p-10 ">
        <Outlet />
      </div>
      <Footer />
    </>
  );
};

export default MaxLayout;
